import { Suspense } from "react";
import { useLocation, Outlet } from "react-router-dom";
import { Navbar } from "@/components/navbar";
import { Footer } from "@/components/footer";
import { ScrollToTopButton } from "@/components/scroll-to-top-button";
import { ContactOverlay } from "@/components/contact-overlay";
import { CancellationOverlay } from "@/components/cancellation-overlay";
import { AppLoader } from "@/components/ui/app-loader";

export function LayoutChrome() {
  const location = useLocation();
  const isKursplan = location.pathname === "/kursplan";
  const isReformer = location.pathname === "/reformer-pilates";
  const isHome = location.pathname === "/";

  return (
    <>
      <Navbar />
      <Suspense fallback={<AppLoader className="min-h-screen" />}>
        <Outlet />
      </Suspense>
      {!isKursplan && !isReformer && !isHome && <Footer />}
      <ScrollToTopButton />
      <ContactOverlay />
      <CancellationOverlay />
    </>
  );
}
